export default class CommonApi{
    static getHost(){
        if(process.env.REACT_APP_PRODUCTION == 1) return process.env.REACT_APP_PRODUCTION_HOST; else
            return process.env.REACT_APP_LOCAL_HOST;
    }
}